import {
  DEALTAG_LOADING,
  GET_DEALTAG,
  GET_DEALTAG_SUCCESS,
  GET_DEALTAG_FAIL,
  ADD_DEALTAG_SUCCESS,
  ADD_DEALTAG_FAIL,
  DELETE_DEALTAG_SUCCESS,
  DELETE_DEALTAG_FAIL,
  UPDATE_DEALTAG_SUCCESS,
  UPDATE_DEALTAG_FAIL,
  DEALTAG_RESET,
} from "./actionType";

const INIT_STATE = {
  dealTags: [],
  error: {},
};

const DealTag = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DEALTAG_SUCCESS:
      switch (action.payload.actionType) {
        case GET_DEALTAG:
          return {
            ...state,
            dealTags: action.payload.data,
            isDealTagCreated: false,
            isDealTagSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_DEALTAG_FAIL:
      switch (action.payload.actionType) {
        case GET_DEALTAG_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isDealTagCreated: false,
            isDealTagSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_DEALTAG: {
      return {
        ...state,
        isDealTagCreated: false,
        loading: true,
      };
    }

    case DEALTAG_LOADING: {
      return {
        ...state,
        isDealTagCreated: false,
        loading: true,
      };
    }

    case ADD_DEALTAG_SUCCESS:
      return {
        ...state,
        isDealTagCreated: true,
        loading: false,
        dealTags: [action.payload.data, ...state.dealTags],
      };

    case ADD_DEALTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_DEALTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealTagCreated: true,
        dealTags: state.dealTags.filter(
          (dealTag) => dealTag.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_DEALTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_DEALTAG_SUCCESS:
      return {
        ...state,
        loading: false,
        isDealTagCreated: true,
        dealTags: state.dealTags.map((dealTag) =>
          dealTag.id.toString() === action.payload.data.id.toString()
            ? { ...dealTag, ...action.payload.data }
            : dealTag
        ),
      };

    case UPDATE_DEALTAG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DEALTAG_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default DealTag;
